import { render, staticRenderFns } from "./MilestoneDismissed.vue?vue&type=template&id=006d3021&"
import script from "./MilestoneDismissed.vue?vue&type=script&lang=js&"
export * from "./MilestoneDismissed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports